import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1ad7f203&scoped=true&lang=pug&"
import script from "./list.vue?vue&type=script&lang=ts&"
export * from "./list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad7f203",
  null
  
)

export default component.exports